// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_routes_admin_components_media-zoom-modal_media-zoom-modal_component_ts-node_m-aa666c":"8a1ddf08ad32351d","src_app_routes_sst_sst_module_ts":"f98dc92abe8e01e6","src_app_routes_admin_admin_module_ts":"0efe0e74001aed97"}[chunkId] + ".js";
};